var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.05,
    height: 20.279,
    viewBox: "0 0 16.05 20.279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0412\\u043E\\u043A\\u0437\\u0430\\u043B\\u0438",
    transform: "translate(-20.622 -714.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(22.175 724.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_020---Train",
    "data-name": "020---Train",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M14,35H.5a.5.5,0,0,0-.5.5v.25a.5.5,0,0,0,.5.5H14a.5.5,0,0,0,.5-.5V35.5A.5.5,0,0,0,14,35Z",
    transform: "translate(0 -26.251)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M8,10.5a.25.25,0,0,0,.25-.25v-4A.25.25,0,0,0,8,6H6.25A.25.25,0,0,0,6,6.25v4a.25.25,0,0,0,.25.25Zm-1.25-4H7.5a.25.25,0,0,1,0,.5H6.75a.25.25,0,0,1,0-.5Zm0,1H7.5a.25.25,0,0,1,0,.5H6.75a.25.25,0,0,1,0-.5Z",
    transform: "translate(-4.5 -4.5)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M38,6.25V8a.25.25,0,0,0,.25.25h3.767L40.517,6H38.25A.25.25,0,0,0,38,6.25Z",
    transform: "translate(-28.501 -4.5)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M9.242,7.5h.512a1.375,1.375,0,0,0,2.737,0h.254a1.75,1.75,0,0,0,1.732-2.007.2.2,0,0,1-.055.007H11.248a.25.25,0,1,1,0-.5h3.077a1.765,1.765,0,0,0-.125-.22l-.352-.53h-4.1A.752.752,0,0,1,9,3.5V1.75A.752.752,0,0,1,9.749,1h1.935L11.536.78A1.752,1.752,0,0,0,10.078,0H.5A.5.5,0,0,0,0,.5V5H1V1.75A.752.752,0,0,1,1.75,1H3.5a.752.752,0,0,1,.75.75V5H10a.25.25,0,1,1,0,.5H4.249v.25a.752.752,0,0,1-.75.75H1.75A.752.752,0,0,1,1,5.749V5.5H0v2H6.505a1.375,1.375,0,0,0,2.737,0Zm-.994-4a.752.752,0,0,1-.75.75H5.749A.752.752,0,0,1,5,3.5V1.75A.752.752,0,0,1,5.749,1H7.5a.752.752,0,0,1,.75.75Zm2.875,4.749a.877.877,0,0,1-.866-.75h1.732A.877.877,0,0,1,11.123,8.249Zm-3.25,0a.877.877,0,0,1-.866-.75H8.74A.877.877,0,0,1,7.874,8.249Z",
    transform: "translate(0)",
    fill: "current"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "departure",
    transform: "translate(19.669 655.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_608",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 608",
    transform: "translate(0.953 58.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_607",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 607",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1676",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1676",
    d: "M44.824,59.232a1.337,1.337,0,0,0-1.85-.475l-3.508,2.123-3.852-2.531-2.343,1.335,2.972,3.146-3.61,2.185-1.73-.782-1.61.929,2.411,1.645,2.017.092,10.589-5.826A1.337,1.337,0,0,0,44.824,59.232Z",
    transform: "translate(-29.294 -58.348)",
    fill: "current"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStation);
export default __webpack_public_path__ + "static/media/Station.66a4b804b5e4d4ff96666412d1d6469a.svg";
export { ForwardRef as ReactComponent };